module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vdr",
    class: {
      draggable: _vm.draggable, resizable: _vm.resizable, active: _vm.enabled, dragging: _vm.dragging, resizing: _vm.resizing
    },
    style: (_vm.style),
    on: {
      "mouseover": _vm.mouseOver,
      "mouseleave": _vm.mouseLeave,
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.elmDown($event)
      },
      "dblclick": _vm.fillParent
    }
  }, [_vm._l((_vm.handles), function(handle) {
    return (_vm.resizable) ? _c('div', {
      staticClass: "handle",
      class: 'handle-' + handle,
      style: ({
        display: _vm.enabled ? 'block' : 'none'
      }),
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.handleDown(handle, $event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5dcab279!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/vue-draggable-resizable.vue
// module id = 434
// module chunks = 1